(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/view-options/vikinglotto.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/view-options/vikinglotto.js');

'use strict';

svs.numbergames.game.view_options.VIKINGLOTTO = {
  multiHuxFluxArray: [1, 5, 10],
  jokerInfoTemplate(_ref) {
    let {
      isSubscription
    } = _ref;
    if (svs.numbergames.game.draw.isJokerOpen) return '';
    if (isSubscription) {
      return 'Med <span class="f-bold">Joker</span> kommer din prenumeration som tidigast starta <span class="f-bold">nästa vecka</span>.';
    }
    return 'Joker har spelstopp <span class="f-bold">ons 17:15</span> och är därefter inte spelbart fram till Vikinglottos spelstopp <span class="f-bold">ons 18:00.</span>';
  }
};

 })(window);